import React from 'react';

import './footer.styles.scss';
import { ProfileConsumer } from 'providers/profile.provider';

const YEAR = new Date().getFullYear();

const FooterLayout: React.FC = (): JSX.Element => (
    <div className="footer">
        <div className="inner">
            <p>©2016-{ YEAR } BizCapital Correspondente Bancário Ltda. (CNPJ: 24.077.504/0001-78). Todos os direitos reservados.</p>
            <p>A BizCapital Correspondente Bancário Ltda. não é um banco ou uma instituição financeira, mas prestador de serviços de correspondente bancário à Socinal S.A. - Crédito, Financiamento e Investimento (CNPJ: 03.881.423/0001-56) e à BMP Money Plus Sociedade de Crédito Direto S.A. (CNPJ: 34.337.707/0001-00). Por meio da nossa plataforma digital, você terá acesso ao produto “Empréstimo para Capital de Giro – Pessoa Jurídica” oferecido por essas duas instituições financeiras.</p>
            <p>Prazo de pagamento: de 3 a 24 meses. Custo Efetivo Total (CET): De 2,90% a.m. (40,97% a.a.) a 8,41% a.m. (163,54% a.a.). Exemplo: um empréstimo de R$ 20.000,00 com pagamento em 12 parcelas R$ 2.122,24. O valor total a ser pago será de R$ 25.466,88, com juros de 2,99% a.m. e CET de 3,88% a.m.</p>
            <p>Para maiores informações, consulte a Resolução nº. 3.954, de 24 de fevereiro de 2011 do Banco Central do Brasil. Para entrar em contato com as instituições financeiras, acesse:</p>
            <p>SOCINAL – Ouvidoria: 0800 282 4193 | Contato: <a href="mailto:ouvidoria@socinal.com.br">ouvidoria@socinal.com.br</a></p>
            <p>BMP Money Plus – Ouvidoria: 0800 601 5289 | Contato: <a href="mailto:atendimento@moneyp.com.br">atendimento@moneyp.com.br</a></p>
        </div>
    </div>
);

const Footer: React.FC = (): JSX.Element => (
    <ProfileConsumer>
        {({ isPartner }) => isPartner && <FooterLayout />}
    </ProfileConsumer>
);

export default Footer;
